import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Page } from "../components/Primitives";

const TABS = [
  { to: "/service/intake", label: "Intake", test: "tab-intake" },
  { to: "/service/jobcards", label: "Job Cards", test: "tab-jc" },
  { to: "/service/wip", label: "Work in Progress", test: "tab-wip" },
  { to: "/service/testdrives", label: "Test Drives", test: "tab-td" },
];

export default function Service() {
  const loc = useLocation();

  return (
    <Page
      number="04"
      title="Service Shop"
      subtitle="Intake → Estimate → Approval → Work → Delivery. Every step, every photo, every spare — tracked."
    >
      <div className="kk-tabs mb-8">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={t.test}
            className={({ isActive }) => "kk-tab " + (isActive ? "kk-tab-active" : "")}
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </Page>
  );
}
